import { render, staticRenderFns } from "./baofu.vue?vue&type=template&id=327d4332&"
import script from "./baofu.vue?vue&type=script&lang=js&"
export * from "./baofu.vue?vue&type=script&lang=js&"
import style0 from "./baofu.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports